export default "__VITE_ASSET__90G9xOq0__"